import {SHOW_ALLPHOTO} from './type';

export function showAllPhotoPopup(visible) {
    return function(dispatch) {
        dispatch({
            type: SHOW_ALLPHOTO,
            payload: visible
        });
    }
}